export default __webpack_public_path__ + "static/media/Dazzed-Medium.5708f499.woff2";